import React from "react";
import Ajax, { domain } from "../ajax/Ajax";

class Subscribe extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      submitting: false,
      subscription: null,
      subscribedSuccess: false,
      subscribedError: false,
    };

    this.submitEmail = this.submitEmail.bind(this);
  }

  async submitEmail(event) {
    event.preventDefault();

    this.setState({
      submitting: true,
    });

    let data = {
      email: this.state.email,
    };

    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/subscribe/",
      data
    );
    if (response) {
      this.setState({
        submitting: false,
        subscribedSuccess: true,
        subscribedError: false,
        email: "",
      });
    } else {
      this.setState({
        submitting: false,
        subscribedError: true,
        subscribedSuccess: false,
      });
    }
  }

  render() {
    let submit = "";
    if (this.state.submitting) {
      submit = "is-loading";
    }
    return (
      <div className="has-background-info subscribe">
        <br />
        <br />
        <div className="container">
          <div className="columns">
            <div className="column is-3"></div>
            <div className="column is-6">
              <form action="#" onSubmit={this.submitEmail} className="box">
                <div className="field has-text-centered is-size-5">
                  Subscribe for updates
                </div>

                {this.state.subscribedSuccess ? (
                  <div className="message is-success animated fadeIn">
                    <div className="message-body has-text-centered">
                      <span className="zmdi zmdi-check-circle mr-2"></span>
                      <span>Successfully Subscribed</span>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                {this.state.subscribedError ? (
                  <div className="message is-danger animated fadeIn">
                    <div className="message-body has-text-centered">
                      <span className="zmdi zmdi-close-circle mr-2"></span>
                      <span>An Error occurred. Please try again later.</span>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                <div className="field control has-icons-left">
                  <input
                    onChange={(event) => {
                      this.setState({
                        email: event.target.value,
                      });
                    }}
                    value={this.state.email}
                    placeholder="Your Email"
                    type="email"
                    required
                    className="input"
                    name="email"
                  />
                  <span className="icon is-left">
                    <span className="zmdi zmdi-email"></span>
                  </span>
                </div>
                <div className="field">
                  <button
                    className={"button is-primary is-fullwidth " + submit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <div className="column is-3"></div>
          </div>
        </div>
        <br />
        <br />
      </div>
    );
  }
}

export default Subscribe;
